<template>
  <div>
    <div class="page-content">
      <div class="bg-light py-2"></div>
      <div class="container py-md-5 py-4">
        <div class="row mb-3">
          <div class="col-md-6">
            <h3 class="font-bold font-22">
              Newly Joined Members ({{ this.count }})
            </h3>
          </div>
          <!-- <div class="col-md-6 text-md-end text-center">
              <a href="" class="font-bold font-18">View All </a>
            </div> -->
        </div>
        <div class="tab-content form-style">
          <div
            class="tab-pane fade show active"
            id="tab_1"
            role="tabpanel"
            aria-labelledby=""
          >
            <div
              class="border-top py-4"
              v-for="(data, index) in list"
              :key="index"
            >
              <div class="row">
                <div class="col-lg-3 col-md-4 mb-4 position-relative">
                  <div
                    :id="'ProfileSlider_' + index"
                    class="carousel slide profile-sider"
                    data-bs-ride="carousel"
                    data-bs-interval="false"
                    v-if="data"
                  >
                    <div
                      class="carousel-inner rounded-l cursor-pointer"
                      v-if="
                        data.user_images.length > 0 || data.user_images != null
                      "
                    >
                      <div
                        class="carousel-item"
                        v-for="(data1, index1) in data.user_images"
                        :key="index1"
                        :class="index1 == 0 ? 'active' : ' '"
                      >
                        <img
                          :src="
                            data1.image
                              ? data1.image
                              : '/img/profile-holder.png'
                          "
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div
                      class="carousel-inner rounded-l new cursor-pointer"
                      v-if="
                        data.user_images.length == 0 || data.user_images == null
                      "
                    >
                      <div class="carousel-item active">
                        <img
                          src="/img/profile-holder.png"
                          class="photos"
                          alt="..."
                        />
                      </div>
                    </div>
                    <div v-show="data.user_images.length">
                      <button
                        class="carousel-control-prev"
                        type="button"
                        :data-bs-target="'#ProfileSlider_' + index"
                        data-bs-slide="prev"
                      >
                        <span
                          class="carousel-control-prev-icon"
                          aria-hidden="true"
                        ></span>
                        <span class="visually-hidden">Previous</span>
                      </button>
                    </div>
                    <div v-show="data.user_images.length > 0">
                      <button
                        class="carousel-control-next"
                        type="button"
                        :data-bs-target="'#ProfileSlider_' + index"
                        data-bs-slide="next"
                      >
                        <span
                          class="carousel-control-next-icon"
                          aria-hidden="true"
                        ></span>
                        <span class="visually-hidden">Next</span>
                      </button>
                    </div>
                  </div>
                  <div
                    class="text-center my-3 carousel-counter"
                    id="slide-counter"
                  >
                    <div class="num text-white"></div>
                  </div>
                </div>
                <div
                  class="col-lg-7 col-md-8 cursor-pointer"
                  v-on:click="goToUrl($event, data.uuid)"
                >
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-6">
                          <label for="">Reg. No.</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.registration_no ? data.registration_no : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <!--      v-if="mydetails.is_membership_subscribed == 'N'"   v-if="mydetails.is_membership_subscribed == 'Y'" -->
                      <div class="row">
                        <div class="col-6">
                          <label for="">Surname</label>
                        </div>
                        <div class="col-6" style="word-break: break-word">
                          <p class="font-medium pink-clr">
                            <!-- {{ data.first_name ? data.first_name : "" }}
                            {{ data.middle_name ? data.middle_name : "" }} -->
                            {{ data.last_name ? data.last_name : "" }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="row"
                        v-if="myDetails.is_membership_subscribed == 'N'"
                      >
                        <div class="col-6">
                          <label for="">Surname</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{ data.last_name ? data.last_name : "-" }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">Native</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.native_place_district
                                ? data.native_place_district.name
                                : ""
                            }}
                            {{
                              data.native_place_taluka
                                ? " - " + data.native_place_taluka.name
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">DOB</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.dob
                                ? $helperService.getFormatedDate(data.dob)
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">Height</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.height
                                ? $helperService.getHeight(data.height)
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-6">
                          <label for="">Education</label>
                        </div>
                        <div class="col-6">
                          <p
                            :title="
                              data.education_courses
                                ? data.education_courses
                                : ''
                            "
                            class="font-medium"
                          >
                            {{
                              data.education_courses
                                ? $helperService.getText(
                                    data.education_courses,
                                    40
                                  )
                                : "NA"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">Occupation</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.occupation_type
                                ? data.occupation_type.name
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">Ann. Inc. (Lakh)</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.annual_income || data.annual_income == 0
                                ? $helperService.kFormatter(data.annual_income)
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label for="">Working city</label>
                        </div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{
                              data.working_place_taluka
                                ? data.working_place_taluka.name
                                : "-"
                            }}
                          </p>
                        </div>
                      </div>

                      <!-- <div class="row">
                        <div class="col-6"><label for="">Gan</label></div>
                        <div class="col-6">
                          <p class="font-medium">
                            {{ data.gan ? data.gan.name : "-" }}
                          </p>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-4 ps-md-0">
                  <!-- <button
                    v-on:click="showRemmaingtactModel(data.uuid)"
                    class="btn btn-outline-brand-1 mb-2 w-100"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button> -->
                  <button
                    v-if="!data.hasViewContact"
                    v-on:click="showRemmaingtactModel(data.uuid)"
                    class="btn btn-outline-brand-1 mt-2 mb-3 w-100"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button>
                  <button
                    v-if="data.hasViewContact"
                    v-on:click="showRemmaingtactModel(data.uuid)"
                    class="btn btn-brand-1 mt-2 mb-3 w-100"
                  >
                    <i class="fa fa-eye font-20 me-2" aria-hidden="true"></i>
                    View Contact
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-brand-1 mb-2 w-100 px-2"
                    v-if="!data.hasSentIntrest"
                    v-on:click="sendIntrest(data)"
                  >
                    <i
                      class="fa fa-paper-plane font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    Send Interest
                  </button>
                  <button
                    type="button"
                    class="btn btn-brand-1 w-100 mb-2"
                    v-if="data.hasSentIntrest"
                    v-on:click="notIntrested(data)"
                  >
                    <i
                      class="fa fa-paper-plane font-20 me-2"
                      aria-hidden="true"
                    ></i>
                    Cancel Interest
                  </button>
                  <div
                    class="btn-group w-100"
                    role="group"
                    aria-label="Basic checkbox toggle button group"
                    v-if="!data.hasShortListed"
                  >
                    <input
                      type="checkbox"
                      class="btn-check"
                      :id="'btncheck1_' + index"
                      autocomplete="off"
                    />
                    <label
                      class="btn btn-outline-brand-1 mb-2 w-100"
                      :for="'btncheck1_' + index"
                      v-on:click="shortlist(data)"
                      ><i
                        class="fa fa-heart font-20 me-2"
                        aria-hidden="true"
                      ></i>
                      Shortlist</label
                    >
                  </div>
                  <button
                    type="button"
                    class="btn btn-brand-1 w-100 mb-2"
                    v-if="data.hasShortListed"
                    v-on:click="removeShortlisted(data)"
                  >
                    <i class="fa fa-heart font-20 me-2" aria-hidden="true"></i>
                    Shortlisted
                  </button>
                  <div class="dropdown">
                    <button
                      type="button"
                      :class="
                        data.hasBlocked || data.hasReported
                          ? 'btn-brand-1'
                          : 'btn-outline-brand-1'
                      "
                      class="btn w-100 dropdown-toggle"
                      id="dropdownMore"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i
                        class="fa fa-ellipsis-v font-20 me-2"
                        aria-hidden="true"
                      ></i>
                      More
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMore">
                      <li>
                        <a
                          class="dropdown-item"
                          href="#"
                          v-on:click="showSharePopup(data.to_user_id)"
                          ><i class="fa fa-share-alt" aria-hidden="true"></i>
                          Share Profile</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item cursor-pointer"
                          v-if="!data.hasBlocked"
                          v-on:click="blockUser(data)"
                          ><i class="fa fa-ban" aria-hidden="true"></i> Block
                          User</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item cursor-pointer"
                          v-if="data.hasBlocked"
                          v-on:click="unblockUser(data)"
                          ><i class="fa fa-ban" aria-hidden="true"></i>
                          Unblock</a
                        >
                      </li>
                      <li>
                        <a
                          v-if="data.hasReported == 0"
                          class="dropdown-item cursor-pointer"
                          v-on:click="showReportUser(data)"
                          ><i class="fa fa-flag" aria-hidden="true"></i> Report
                          This User</a
                        >
                      </li>
                      <li>
                        <a
                          v-if="data.hasReported"
                          class="dropdown-item cursor-pointer"
                          style="color: red; font-weight: 401"
                          ><i
                            class="fa fa-flag"
                            aria-hidden="true"
                            style="color: red"
                          ></i>
                          Already Reported</a
                        >
                      </li>
                      <!-- <li>
                              <a class="dropdown-item" v-if="data.hasReported"
                                ><i class="fa fa-flag" aria-hidden="true"></i>
                                Reported</a
                              >
                            </li> -->
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <ErrorComponent @retry="getList(0)" ref="errorComponent" />
            <div class="row mx-0 mb-4">
              <div
                class="col-lg-12 mt-5 text-right"
                style="text-align-last: end"
              >
                <div class="page-bottom-pagination text-right">
                  <Pagination
                    @page-change="pageChange"
                    @items-per-page-change="itemsPerPageChange"
                    ref="listPagination"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <MainFooter />
  <!-- View Reason  -->
  <div
    class="modal fade"
    id="ViewReason"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">View Reason</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Perspiciatis asperiores repellat ipsa enim nobis! Dignissimos quod
            quo deserunt delectus animi perspiciatis aut, perferendis libero,
            voluptatem hic nemo quisquam iure. Vel.
          </p>
        </div>
      </div>
    </div>
  </div>

  <TextModal ref="viewMembershipPlan">
    <div>
      <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
        <div class="col-1" style="text-align-last: end"></div>
      </div>
      <div class="modal-body pt-0 form-style">
        <div class="row">
          <button
            type="button"
            class="btn-close"
            style="margin-left: auto; margin-top: -58px; margin-right: -10px"
            v-on:click="$refs.viewMembershipPlan.closeModal()"
          ></button>
        </div>
        <div class="form-group">
          <h4 class="text-center">You are a free member</h4>
          <p>
            Buy a paid membership to see contact no. & some hidden information
          </p>
        </div>
        <div class="text-center">
          <router-link to="/membership-plans" class="btn btn-brand-1 btn-block">
            View membership plan
          </router-link>
        </div>
      </div>
    </div>
  </TextModal>
  <TextModal ref="remainingContacts">
    <div>
      <div class="row border-0 text-align-last-center">
        <div class="col-1" style="text-align-last: end"></div>
      </div>
      <div class="modal-body pt-0 form-style">
        <div class="row">
          <button
            type="button"
            class="btn-close"
            style="margin-left: auto"
            v-on:click="$refs.remainingContacts.closeModal()"
          ></button>
        </div>
        <div class="form-group">
          <h4 class="text-center">View Contact</h4>
          <p>
            Your Total Remaining Contact View is -
            {{ remaining_contact_view_count }}
          </p>
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-brand-1 w-100 mb-3"
            v-on:click="showContactModel()"
          >
            View Contact
          </button>
        </div>
      </div>
    </div>
  </TextModal>
  <!-- photo gallery  -->
  <!-- Modal -->
  <div
    class="modal fade"
    id="photosModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog photos-gallery modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close bg-light"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div
            id="carouselExampleIndicators"
            class="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="false"
          >
            <div class="carousel-indicators">
              <button
                class="thumb-btn active"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                aria-current="true"
                aria-label="Slide 1"
              >
                <img
                  src="images/profile-female-1.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
              <button
                class="thumb-btn"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              >
                <img
                  src="images/profile-female-2.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
              <button
                class="thumb-btn"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              >
                <img
                  src="images/profile-female-3.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
              <button
                class="thumb-btn"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="3"
                aria-label="Slide 3"
              >
                <img
                  src="images/profile-female-4.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
              <button
                class="thumb-btn"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="4"
                aria-label="Slide 2"
              >
                <img
                  src="images/profile-female-5.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
              <button
                class="thumb-btn"
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="5"
                aria-label="Slide 3"
              >
                <img
                  src="images/profile-female-6.jpg"
                  class="thumbnail-img"
                  alt="..."
                />
              </button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="images/profile-female-1.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="images/profile-female-2.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="images/profile-female-3.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="images/profile-female-4.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="images/profile-female-5.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="images/profile-female-6.jpg"
                  class="w-100"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <TextModal ref="reportModal">
    <div class="modal-content">
      <div class="modal-header px-md-5 border-0">
        <div class="row">
          <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
          <button
            type="button"
            class="btn-close"
            v-on:click="$refs.reportModal.closeModal()"
          ></button>
        </div>
      </div>
      <div class="modal-body px-4">
        <h5 class="modal-title font-22 mb-0 text-center mb-3">Report</h5>
        <Form ref="reportForm" @submit="reportUser()">
          <div class="floating-form mb-4">
            <div class="floating-form-group mt-4 mb-2" style="height: 130px">
              <Field
                as="textarea"
                type="text"
                rows="4"
                style="width: 100%;"
                name="message"
                rules="required:message"
                :validateOnInput="true"
                v-model="reportObj.message"
              />

              <label for="message">Please write your problem/suggestion</label>
              <span class="text-danger">*</span>
            </div>
            <ErrorMessage name="message" class="text-danger" />
          </div>
          <div class="text-center">
            <button class="btn btn-brand-1" id="submit-button3">Submit</button>
          </div>
        </Form>
      </div>
    </div>
  </TextModal>

  <ShareModal ref="shareModal" />
  <ImageGalleryModel ref="galleryModel">
    <div
      class="modal-dialog photos-gallery modal-dialog-centered"
      style="height: 500px; min-width: 500px !important"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close bg-light"
            v-on:click="closeModel()"
          ></button>
        </div>
        <div class="modal-body">
          <div>
            <div class="text-center">
              <img
                v-if="selected_image"
                style="width: 100%; object-fit: contain; height: 100%"
                id="preview"
                :src="selected_image"
                width="1000"
                height="800"
              />
            </div>
          </div>
          <div class="image-gallary d-flex">
            <div
              class="col-2"
              v-for="(data, index) in detail.user_images"
              :key="index"
            >
              <div v-if="data.image" v-on:click="changeImage(data.image)">
                <img :src="data.image" width="50" height="50" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ImageGalleryModel>
  <ConteactViewModel ref="ConteactViewModel" />
</template>
<script>
import $ from "jquery";
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import Pagination from "@/components/Pagination";
import ShareModal from "@/views/SocialShare/ShareModal.vue";
import TextModal from "@/components/TextModal.vue";
import ImageGalleryModel from "@/components/ImageGalleryModel.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  name: "UserDashboard",
  components: {
    ErrorComponent,
    ConteactViewModel,
    Pagination,
    ImageGalleryModel,
    ShareModal,
    TextModal,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loader: false,
      remaining_contact_view_count: 0,
      offset: -1,
      keyword: "",
      count: "",
      uuid: "",
      searchObj: {},
      report_id: "",
      reportObj: {},
      contentDetail: {},
      detail: {
        user_images: [],
      },
      selected_image: "",
      myDetails: {},
      counts: {},
      list: [],
    };
  },
  mounted() {
    this.getMecall();
    this.getCounts();
    this.getList(0);
    var totalItems = $(".carousel-item").length;
    var currentIndex = $(".carousel-item.active").index() + 1;
    $(".num").html("" + currentIndex + "/" + totalItems + "");

    $("#ProfileSlider").bind("slid", function () {
      currentIndex = $(".carousel-item.active").index() + 1;
      $(".num").html("" + currentIndex + "/" + totalItems + "");
    });
    this.moveToContacat(0);
  },
  methods: {
    changeImage(image) {
      this.selected_image = "";
      this.selected_image = image;
      document.getElementById("preview").src = image;
    },
    closeModel() {
      this.detail.user_images = [];
      this.selected_image = "";
      this.$refs.galleryModel.closeModal();
    },
    showUserGallery(user_images) {
      if (user_images.length > 0) {
        this.selected_image = user_images[0].image;
        this.detail.user_images = user_images;
        this.$refs.galleryModel.showModal();
      }
    },
    getMecall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.myDetails = res;
        })
        .catch(() => {});
    },
    getCounts() {
      this.$api
        .getAPI({
          _action: "/get-activity-count",
        })
        .then((res) => {
          this.counts = res;
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    goToUrl(e, uuid) {
      var obj = {};
      obj.ht = e.layerY;
      obj.offset = this.offset - 1;
      this.$shareService.setMapValue("new_joined_search_list", obj);
      this.$router.push("/profile-view/" + uuid);
    },
    getList(offset, orderBy, sortBy) {
      window.scrollTo(0, 0);
      this.$refs.errorComponent.updateListLoader(true);
      this.loader = true;
      this.list = [];
      var shareobj = this.$shareService.getMapValue("new_joined_search_list")
        ? this.$shareService.getMapValue("new_joined_search_list")
        : null;
      this.searchObj.offset =
        shareobj && shareobj.offset ? shareobj.offset : offset;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/joined/member/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.count = res.count;
          this.list = res.list;
          this.offset = res.next_offset;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "Member List Not Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
          this.moveToContacat();
          this.$shareService.setMapValue("new_joined_search_list", null);
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined);
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    moveToContacat() {
      var shareobj = this.$shareService.getMapValue("new_joined_search_list")
        ? this.$shareService.getMapValue("new_joined_search_list")
        : null;
      if (shareobj && shareobj.ht) {
        setTimeout(() => {
          window.scrollTo(0, Number(shareobj.ht) - 190);
        }, 100);
      } else {
        window.scrollTo(0, 0);
      }
    },
    sendIntrest(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    getName(first, middle, last) {
      var name = "";
      if (first) {
        // name = first + " ";
      }
      if (middle) {
        // name = name + middle + " ";
      }
      if (last) {
        name = name + last;
      }
      return name;
    },
    notIntrested(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    showSharePopup(uuid) {
      this.url = window.location.href;
      var url = this.url.replaceAll(
        "/recently-viewed",
        "/profile-view/" + uuid
      );

      this.url = url;
      this.$refs.shareModal.showModal(this.url, "Profile");
    },
    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.errorComponent.updateFormLoader(true);
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.contentDetail = res;
          this.$refs.remainingContacts.closeModal();
          this.$refs.errorComponent.updateFormLoader(false);
          this.getList(this.offset - 1);
          this.$refs.ConteactViewModel.showModal(this.contentDetail);
        })
        .catch(() => {
          this.$refs.remainingContacts.closeModal();
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
    shortlist(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      if (obj.to_user_id) {
        this.$api
          .postAPI({
            _action: "/short-list",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (data.hasShortListed = 1);
          })
          .catch(() => {});
      }
    },
    blockUser(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .postAPI({
          _action: "/block-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasBlocked = 1);
        })
        .catch(() => {});
    },
    unblockUser(data) {
      var obj = {};
      obj.to_user_id = data.uuid ? data.uuid : "";
      this.$api
        .postAPI({
          _action: "/unblock-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.hasBlocked = 0);
        })
        .catch(() => {});
    },
    reportUser() {
      this.reportObj.to_user_id = this.report_id;
      this.$api
        .postAPI({
          _action: "/report-user",
          _body: this.reportObj,
          _buttonId: "submit-Button3",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          for (var i in this.list) {
            if (this.list[i].uuid == this.report_id) {
              this.list[i].hasReported = 1;
            }
          }
          this.$refs.reportModal.closeModal();
          this.changeTab(this.currentTab);
        })
        .catch(() => {});
    },
    removeShortlisted(data) {
      var obj = {};
      if (data.user) {
        obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      } else {
        obj.to_user_id = data.uuid ? data.uuid : "";
      }
      if (obj.to_user_id) {
        this.$api
          .putAPI({
            _action: "/remove-shortlist/" + obj.to_user_id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            return (data.hasShortListed = 0);
          })
          .catch(() => {});
      }
    },
    showReportUser(data) {
      if (data) {
        this.report_id = data.uuid;
      }
      this.$refs.reportForm.resetForm();
      this.$refs.reportModal.showModal();
    },
  },
};
</script>
